import React, { Component } from "react";
import { checkTextTranslation, translate } from "../../../utils/useful";
import FormViewer from "../../FormViewer";
import ExistingForms from "./ExistingForms";
import ButtonAnimated from "../../buttons/ButtonAnimated";

class FormInputConfig extends Component {
    state = {
    };

    init = () => {

    }

    liveChange = (data, init, key, value, extra) => {
        if (!init) {
            this.props.updateInputData(key, value)
        }
    }

    submit = () => {
        let data = this.form.getForm()
        if (data) {

            this.props.submit()
        }
    }

    validateForm = (cb) => {
        let data = this.form.getForm()
        if (data) {
            cb(true)
        } else {
            cb(false)
        }
    }


    render() {


        return (
            <div className="w-100 h-100 bg-white scroll-no-scrollbar  pb-3">
                <div className=" w-100 mb-2 pt-2 pb-2" style={{ borderBottom: '1px solid #f2f6f8', position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
                    <div className=" flexcb  px-3" >
                        <div className="flexc">
                            <div className="br-6 p-1 flexcc grayscale-filter" style={{ background: '#eee', }}>
                                <img src={this.props.input?.icon} height={20} alt="" />
                            </div>

                            <p className="mld-2 text-normal text-semibold">{checkTextTranslation(this.props.input?.label)} Field</p>
                        </div>

                        <div>
                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={this.submit}
                                title={translate('Submit')}
                                icon='/assets/icons/angle-right-white2.svg'
                                textColor={this.props.colors?.textColor ?? '#fff'}
                                // invert={!this.props.colors?.iconInvert}
                                bg={this.props.colors?.background ?? 'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                            />
                        </div>

                        {/* <p className="text-smaller  ">{translate('Configuration')}</p> */}
                    </div>
                </div>

                <div className="w-100 pt-2 px-1">
                    <FormViewer ref={el => this.form = el} liveChange={this.liveChange} headers={this.props.headers} initData={this.props.initData} errors={this.state.errors} formClass="bordered-form" inputClass={'bordered-input'} variables={this.props.variables} />
                </div>
            </div>
        );
    }
}

export default FormInputConfig;
